"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleTranslator = void 0;
const base_1 = require("../common/base");
const pattern_1 = require("../common/pattern");
class RuleTranslator extends base_1.Translator {
    constructor() {
        super();
        this.cache = { name: "__undefined__", chunkOutput: null, rule: null };
    }
    translate(chunkInput, actions = new Map()) {
        //
        const name = chunkInput.rule.name;
        const chunkOutput = Reflect.apply(chunkInput.rule, null, [chunkInput.props]);
        const pattern = pattern_1.translate(chunkOutput, actions);
        //
        this.cache.name = name;
        this.cache.chunkOutput = chunkOutput;
        this.cache.rule = chunkInput.rule;
        //
        const rule = `${name} "${name}" = ${pattern}`;
        return rule;
    }
}
exports.RuleTranslator = RuleTranslator;
